// extracted by mini-css-extract-plugin
export var dropdownButton = "_31-0";
export var fullWidthDropdownButton = "_31-1";
export var icon = "_31-3";
export var iconPlaceholder = "_31-2";
export var shortcutContainer = "_31-4";